import { cn } from '@/lib/utils';
import { columnLabelClass } from '@/components/ui/typography.ts';
import {
  ChangeSummaryTableVariant,
  summaryRowClass,
} from './changeSummaryTableLayout.ts';

const cellClass = cn('whitespace-nowrap pb-2.5 pt-4', columnLabelClass);

/**
 * Pasek nagłówków kolumn tabeli zmian. W dwóch kolumnach zostają dwie etykiety,
 * w jednej nie ma czego opisywać — pozycję opisuje sam wiersz, więc pasek znika.
 */
const ChangeSummaryTableHeader = ({
  variant,
}: {
  variant: ChangeSummaryTableVariant;
}) => (
  <div
    role="row"
    className={cn(
      summaryRowClass(variant),
      '@max-[440px]:hidden border-b border-neutral-100',
    )}
  >
    <div role="columnheader" className={cellClass}>
      Pozycja
    </div>
    <div role="columnheader" className={cn(cellClass, '@max-[700px]:hidden')}>
      Przed
    </div>
    <div role="columnheader" className={cn(cellClass, '@max-[700px]:hidden')}>
      Po zmianie
    </div>
    <div
      role="columnheader"
      className={cn(cellClass, '@max-[700px]:col-start-2', 'text-right')}
    >
      Wpływ
    </div>
  </div>
);

export default ChangeSummaryTableHeader;
